import React from 'react';
import { Button, Input } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

export default class NumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            quantity: this.props.quantity,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.quantity !== this.state.quantity)
            this.setState({ quantity: this.props.quantity });
    }

    decreaseQuantity = (e) => {
        let quantity = this.state.quantity - 1;
        this.setState({ quantity: quantity });
        this.props.updateCart(e, quantity);
    };
    increaseQuantity = (e) => {
        let quantity = this.state.quantity + 1;
        this.setState({ quantity: quantity });
        this.props.updateCart(e, quantity);
    };
    onNumberChange = (e) => {
        const { value } = e.target;
        if (!isNaN(value)) {
            let quantity = parseInt(value);
            if (quantity >= 0) {
                this.setState({ quantity: quantity });
                this.props.updateCart(null, quantity);
            }
        }
    };
    render() {
        return (
            <div className={'number-input'}>
                <Button className={'button decrease'} onClick={this.decreaseQuantity}>
                    <MinusOutlined />
                </Button>
                <Input
                    value={this.state.quantity}
                    onChange={this.onNumberChange}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                />
                <Button className={'button increase'} onClick={this.increaseQuantity}>
                    <PlusOutlined />
                </Button>
            </div>
        );
    }
}
